module.exports = __webpack_public_path__ + "src/assets/games/24/392.jpg";